// extracted by mini-css-extract-plugin
export default {"container":"mcfQJ3Lb9m_DZOw2ExK0","message":"K0K8zJB57DuZOlwWFLwf"};